import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-session-route',
  templateUrl: './session-route.component.html',
  styleUrls: ['./session-route.component.scss'],
})
export class SessionRouteComponent {
  @Input() session: any;
  @Input() scenario: any;

  getStep(stepId: string, scenarioData: any): any {
    let returnstep;
    scenarioData?.steps.forEach((step: any) => {
      if (step.step_id == stepId) {
        returnstep = step;
      }
    });
    return returnstep;
  }
}
